import getMetaContent from "./get-meta-content"

export default (): string => {
  const content = getMetaContent("csrf-token")
  return content || ""
}
